// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.manager {
  width: 100%;
  height: 100%;
}
.arrow-text {
  font-size: 26px;
  color: rgba(255, 255, 255, 0.95);
  font-weight: 600;
  margin: 0;
  line-height: 1.4;
}

.auth-page-close-icon {
  font-size: 60px !important;
  float: none !important;
}
.mobile-warning {
  text-align: center;
  font-size: 22px;
  padding: 70px 30px;
  line-height: 30px;
}
.drag-background {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
  z-index: 9;
}
.drag-info {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 360px;
  padding: 48px 36px;
  text-align: center;
  border: 3px dashed rgba(255, 255, 255, 0.7);
  border-radius: 20px;
  background-color: rgba(255, 255, 255, 0.12);
  pointer-events: none;
}
.waring-title {
  text-align: center;
  margin: 50px 0px 20px;
  font-size: 40px;
  font-weight: 600;
}
.waring-pic {
  width: 80vw;
  position: absolute;
  left: 10vw;
  bottom: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/manager/manager.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,SAAS;EACT,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,2CAA2C;EAC3C,mBAAmB;EACnB,2CAA2C;EAC3C,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd","sourcesContent":[".manager {\n  width: 100%;\n  height: 100%;\n}\n.arrow-text {\n  font-size: 26px;\n  color: rgba(255, 255, 255, 0.95);\n  font-weight: 600;\n  margin: 0;\n  line-height: 1.4;\n}\n\n.auth-page-close-icon {\n  font-size: 60px !important;\n  float: none !important;\n}\n.mobile-warning {\n  text-align: center;\n  font-size: 22px;\n  padding: 70px 30px;\n  line-height: 30px;\n}\n.drag-background {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0px;\n  left: 0px;\n  z-index: 9;\n}\n.drag-info {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 360px;\n  padding: 48px 36px;\n  text-align: center;\n  border: 3px dashed rgba(255, 255, 255, 0.7);\n  border-radius: 20px;\n  background-color: rgba(255, 255, 255, 0.12);\n  pointer-events: none;\n}\n.waring-title {\n  text-align: center;\n  margin: 50px 0px 20px;\n  font-size: 40px;\n  font-weight: 600;\n}\n.waring-pic {\n  width: 80vw;\n  position: absolute;\n  left: 10vw;\n  bottom: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
